import React, { useState } from 'react';
import { EXPENSE_CATEGORIES } from '../../utils/constants';
import { formatCurrency } from '../../utils/formatters';
import { RxTrash } from 'react-icons/rx';

export default function ExpenseEntry({ expenses = [], onChange }) {
  const [form, setForm] = useState({ category: 'fuel', description: '', amount: '' });

  const handle = (e) => setForm(p => ({ ...p, [e.target.name]: e.target.value }));

  const add = () => {
    if (!form.amount || !form.category) return;
    onChange([...expenses, { ...form, id: Date.now() }]);
    setForm({ category: 'fuel', description: '', amount: '' });
  };

  const remove = (id) => onChange(expenses.filter(e => e.id !== id));

  const total = expenses.reduce((s, e) => s + Number(e.amount), 0);

  return (
    <div>
      <div style={{ background: 'var(--gray-50)', border: '1px solid var(--gray-200)', borderRadius: 'var(--radius-md)', padding: '1rem', marginBottom: '0.75rem' }}>
        <div className="grid-3" style={{ gap: '0.5rem' }}>
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label className="form-label">Category</label>
            <select className="form-control" name="category" value={form.category} onChange={handle}>
              {EXPENSE_CATEGORIES.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
            </select>
          </div>
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label className="form-label">Amount (KES)</label>
            <input className="form-control" type="number" name="amount" value={form.amount} onChange={handle} placeholder="0" min="0" style={{ fontFamily: 'var(--font-mono)' }} />
          </div>
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label className="form-label">Description</label>
            <input className="form-control" name="description" value={form.description} onChange={handle} placeholder="Optional note" />
          </div>
        </div>
        <button type="button" className="btn btn-secondary btn-sm" style={{ marginTop: '0.75rem' }} onClick={add}>
          + Add Expense
        </button>
      </div>

      {expenses.length > 0 && (
        <div>
          {expenses.map(e => (
            <div key={e.id} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', padding: '0.5rem 0', borderBottom: '1px solid var(--gray-100)' }}>
              <span style={{ flex: 1, fontSize: '0.875rem', textTransform: 'capitalize' }}>
                {EXPENSE_CATEGORIES.find(c => c.value === e.category)?.label || e.category}
                {e.description && <span style={{ color: 'var(--gray-400)', marginLeft: '0.5rem' }}>— {e.description}</span>}
              </span>
              <span style={{ fontFamily: 'var(--font-mono)', fontSize: '0.875rem', fontWeight: 500 }}>
                {formatCurrency(e.amount)}
              </span>
              <button type="button" className="btn btn-danger btn-sm" style={{ padding: '0.25rem 0.5rem' }} onClick={() => remove(e.id)}>
                <RxTrash size={14} />
              </button>
            </div>
          ))}
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0.625rem 0 0', fontWeight: 600, fontSize: '0.9rem' }}>
            <span>Total Expenses</span>
            <span style={{ fontFamily: 'var(--font-mono)', color: 'var(--danger)' }}>{formatCurrency(total)}</span>
          </div>
        </div>
      )}
    </div>
  );
}